import { ReportInfoItem } from "./ReportInfoItem";
export default ReportInfoItem;
